export enum NotificationTypes {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  OPEN = 'open',
}

export enum NotificationRedirectionEvent {
  PRODUCT_APPROVE = 'product_approve',
  PRODUCT_DECLINE = 'product_decline',
  ACCOUNT_ACTIVATION = 'account_activation',
  PAYMENT_RENEWAL = 'payment_renewal',
  FARM_COMMODITY_DECLINED = 'farm_commodity_declined',
  FARM_COMMODITY_APPROVED = 'farm_commodity_approved',
}
